<template>
  <div v-if="!isNewEdition">
    <div class="select">
      <div style="flex: 1">
        <el-date-picker
          v-model="date1"
          type="daterange"
          range-separator="至"
          start-placeholder="选择时间"
          end-placeholder="选择时间"
          value-format="yyyy-MM-dd"
          size="mini"
          @change="handleDate"
        >
        </el-date-picker>
      </div>
      <div style="padding-right: 20px">
        <el-button size="mini" @click="handleOpen">行为配置</el-button>
      </div>
    </div>
    <div style="display: flex">
      <div class="header">
        <div class="ctx">
          <div class="left"><i class="el-icon-document"></i></div>
          <div class="center">
            <div class="num">{{ chartSum1 }}</div>
            <div>敏感行为数</div>
          </div>
          <div class="right" @click="getEmployeeList">
            查看明细<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="header">
        <div class="ctx">
          <div class="left"><i class="el-icon-user"></i></div>
          <div class="center">
            <div class="num">{{ chartSum2 }}</div>
            <div>敏感行为员工数</div>
          </div>
          <!-- <div class="right">查看明细<i class="el-icon-arrow-right"></i></div> -->
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div
        id="left2"
        style="height: 650px; width: 100%; border-right: 1px solid #ddd"
      ></div>
      <div id="left1" style="height: 650px; width: 100%"></div>
    </div>
    <el-dialog
      title="敏感行为设置"
      :visible.sync="dialogVisible"
      width="32%"
      v-if="dialogVisible"
    >
      <div style="background-color: #f2f2f2">
        选择下列行为中的一些，定义为敏感行为，统计结果跟随设置改变，群聊行为需要开通席位才能进行统计。选择行为后，勾选提醒的条目会在触发时发送消息提醒。
      </div>
      <div style="margin-top: 15px">
        <el-scrollbar style="height: 250px">
          <template v-for="item in list">
            <el-col :span="6" style="margin-bottom: 20px; overflow: hidden">
              <el-checkbox v-model="item.isCheck">{{
                item.msgTypeName
              }}</el-checkbox></el-col
            >
            <el-col :span="6" style="margin-bottom: 20px">
              <el-checkbox
                v-model="item.isRemind"
                class="tips"
                :disabled="!item.isCheck"
                >提醒</el-checkbox
              ></el-col
            >
          </template>
        </el-scrollbar>
      </div>
      <div>
        <div style="margin: 10px 0">消息推送范围：</div>
        <div style="margin-bottom: 10px">
          <el-button icon="el-icon-plus" size="mini" @click="handleSelect"
            >选择推送人</el-button
          >
        </div>
        <div>
          已选:<el-tag
            v-for="(tag, index) in searchMenNames"
            :key="tag.userId"
            closable
            size="mini"
            style="margin: 0 0 7px 7px"
            @close="handleRemove(index)"
          >
            {{ tag.userName }}
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="handleSave">设置完成</el-button>
      </span>
    </el-dialog>
    <StaffTree
      title="选择成员"
      ref="tree"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    />
    <!-- 表格弹窗 -->
    <el-dialog
      title="敏感行为明细表"
      :visible.sync="dialogTableVisible"
      style="height: 1500px"
      @close="dialogTableVisible = false"
      v-if="dialogTableVisible"
    >
      行为筛选：<el-select
        v-model="msgTypeList1"
        placeholder="请选择"
        size="mini"
        multiple
        collapse-tags
        @change="getEmployeeList"
        @clear="getEmployeeList"
      >
        <el-option
          v-for="(item, index) in list"
          :key="index"
          :label="item.msgTypeName"
          :value="item.msgTypeName"
        >
        </el-option>
      </el-select>

      职工筛选：
      <el-select
        v-model="employeeList1"
        multiline
        filterable
        remote
        clearable
        size="mini"
        @focus="clickAddMember"
        @clear="getEmployeeList(1)"
      ></el-select>
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="选择时间"
        end-placeholder="选择时间"
        size="mini"
        value-format="yyyy-MM-dd"
        @change="getEmployeeList"
      >
      </el-date-picker>

      <el-table :data="tableData" style="height: 500px">
        <el-table-column
          property="date"
          label="敏感行为"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          property="name"
          label="触发人"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          property="address"
          label="触发时间"
          align="center"
        ></el-table-column>
        <el-table-column
          property="address"
          label="聊天对象"
          align="center"
        ></el-table-column>
      </el-table>
      <div style="text-align: center; padding-top: 10px">
        <el-pagination
          background
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import Pagination from "@/components/page/Pagination.vue";
import { getOrganization } from "@/api/staffTree/staffTree.js";
import { getSessionVersion } from "@/api/staff/staff.js";
import {
  getSensitiveBehavior,
  saveSensitiveBehavior,
  getStaffSensitive,
  saveStaffSensitive,
  getAllSensitiveBehavior,
  getBehaviorChart,
  getSensitiveEmployee,
  getBehaviorEmployee,
} from "@/api/behaviorChat";
import dayjs from "dayjs";
export default {
  data() {
    return {
      userIdList1: [],
      msgTypeList1: [], //文本类型
      employeeList1: [],
      isFlag: false, //默认是行为配置的员工筛选
      dialogVisible: false,
      dialogTableVisible: false,
      list: [],
      dialogVisibleTree: false,
      currentSelectMember: [],
      searchMenNames: [],
      searchMenNames1: [],
      userIdList: [],
      employeeList: [], //职员id
      msgTypeList: [], //文本类型
      pageSize: 20,
      page: 1,
      total: 0,
      props: { multiple: true, label: "departmentName", value: "departmentId" },
      date: [
        dayjs(this.disabledDate()).format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD"),
      ],
      date1: [
        dayjs(this.disabledDate()).format("YYYY-MM-DD"),
        dayjs().format("YYYY-MM-DD"),
      ],
      tableData: [],
      options: [],
      StaffList: [],
      chartSum1: 0,
      chartSum2: 0,
      // 是否新版会话存档
      isNewEdition: false,
    };
  },
  components: {
    StaffTree,
    Pagination,
  },
  async mounted() {
        /** 获取进入系统后获取到的新旧版进行判断， */
   await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.isNewEdition = res.data
            console.log("dsfsdfsfsdf1111",this.isNewEdition);
            window.localStorage.setItem("isNewEdition", this.isNewEdition);
          } else {
            // this.$message.error("获取版本参数失败")
          }
        }).catch((err) => {
          // this.$message.error("获取版本参数失败")
          console.log("新旧版本参数获取失败", err);
        });
    /** 因为新版没有这几个功能，后端说路由是写死数据库的，不好去掉，也不想加接口，就给增加工作量 */
    if (this.isNewEdition) {
      this.$confirm("功能正在开发中，敬请期待", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          /** 关闭当前路由 */
          this.$store.dispatch("tagsView/delView", this.$route);
          /** 跳转index页面 */
          this.$router.push({ path: "/index" });
        })
        .catch(() => {});
      return;
    }
    this.getLicenseDepartStaff();
    this.getAllBehavior();
    this.getStaff();
    this.getBehaviorChart1();
    this.getBehaviorEmployeeChart();
  },
  methods: {
    clickAddMember() {
      this.isFlag = true;
      this.dialogVisibleTree = true;
    },
    disabledDate() {
      let date = new Date(); // 获取当前日期
      date.setDate(date.getDate() - 30); // 将日期往前推30天
      return date;
    },
    handleSelect() {
      this.dialogVisibleTree = true;
    },
    // 获取职员数据
    async getLicenseDepartStaff() {
      let params = {
        mark: 1,
      };
      this.loading = true;
      let res = await getOrganization(
        params,
        localStorage.getItem("Authorization"),
        true
      );
      if (res.error.code == 200) {
        this.StaffList = res.data.empList;
      }
    },

    handleDate() {
      this.getBehaviorChart1();
      this.getBehaviorEmployeeChart();
    },
    getEmployeeList(type = 0) {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      if (type == 1) {
        this.userIdList1 = [];
      }
      getSensitiveEmployee(
        {
          pageSize: this.pageSize,
          pageNum: this.page,
          employeeList: this.userIdList1,
          msgTypeList: this.msgTypeList1,
          startTime:
            this.date && this.date.length > 0
              ? this.date[0]
              : dayjs().format("YYYY-MM-DD"),
          endTime:
            this.date && this.date.length > 0
              ? this.date[1]
              : dayjs().format("YYYY-MM-DD"),
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.row;
      });
      this.dialogTableVisible = true;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getEmployeeList();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getEmployeeList();
    },
    getBehaviorChart1() {
      getBehaviorChart(
        {
          startTime:
            this.date1 && this.date1.length > 0
              ? this.date1[0]
              : dayjs().format("YYYY-MM-DD"),
          endTime:
            this.date1 && this.date1.length > 0
              ? this.date1[1]
              : dayjs().format("YYYY-MM-DD"),
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        setTimeout(() => {
          this.setChart(res.data, 2);
          this.chartSum1 = 0;
          res.data.forEach((item) => {
            this.chartSum1 += item.value;
          });
        }, 1000);
        res.data.forEach((item) => {
          this.msgTypeList.push(item.name);
        });
      });
    },
    getBehaviorEmployeeChart() {
      getBehaviorEmployee(
        {
          startTime:
            this.date1 && this.date1.length > 0
              ? this.date1[0]
              : dayjs().format("YYYY-MM-DD"),
          endTime:
            this.date1 && this.date1.length > 0
              ? this.date1[1]
              : dayjs().format("YYYY-MM-DD"),
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        setTimeout(() => {
          this.setChart(res.data, 1);
          this.chartSum2 = 0;
          res.data.forEach((item) => {
            this.chartSum2 += item.value;
          });
          // this.setChart(res.data, 2)
        }, 1000);
        res.data.forEach((item) => {
          this.msgTypeList.push(item.name);
        });
        // console.log("resChart", res);
      });
    },
    getBehavior() {
      getSensitiveBehavior(localStorage.getItem("Authorization")).then(
        (res) => {
          let newList = [];
          let indexList = [];
          let listData = [];
          this.list.forEach((item, index) => {
            res.data.forEach((item1) => {
              if (item1.msgType == item.msgTypeName) {
                newList.push({
                  ...item,
                  isRemind: item1.remind,
                  isCheck: true,
                });
                indexList.push(index);
              }
            });
          });
          listData = [...this.list];
          indexList.forEach((item, index) => {
            listData[item] = newList[index];
          });
          this.list = listData;
        }
      );
    },
    getAllBehavior() {
      getAllSensitiveBehavior(localStorage.getItem("Authorization")).then(
        (res) => {
          this.list = res.data;
        }
      );
    },
    saveBehavior(params) {
      saveSensitiveBehavior(params, localStorage.getItem("Authorization"));
    },
    getStaff() {
      getStaffSensitive(localStorage.getItem("Authorization")).then((res) => {
        this.searchMenNames = res.data;
        this.employeeList = res.data.map((item) => {
          return item.userId;
        });
        this.currentSelectMember = res.data;
      });
    },
    saveStaff(params) {
      saveStaffSensitive(params, localStorage.getItem("Authorization"));
    },
    async handleOpen() {
      await this.getBehavior();
      await this.getStaff();
      this.dialogVisible = true;
    },
    async handleSave() {
      let selectList = [];
      this.list.forEach((item) => {
        if (item.isCheck == true) {
          selectList.push({
            isRemind: item.isRemind ? 1 : 0,
            msgType: item.msgTypeName,
          });
        }
      });

      let userId = this.searchMenNames.map((item) => ({
        userId: item.userId,
        userName: item.userName,
        headId: item.headId,
      }));
      await this.saveBehavior(selectList);
      await this.saveStaff(userId);
      this.dialogVisible = false;
      this.getBehaviorChart1();
      this.$message.success("操作成功");
    },
    handleRemove(index) {
      this.searchMenNames.splice(index, 1);
      this.userIdList.splice(index, 1);
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    // 成员树的事件
    clickSubmitTree(val) {
      if (!this.isFlag) {
        this.searchMenNames = [];
        this.currentSelectMember = val.currentMember;
        this.userIdList = [];
        val.sendArray.forEach((item) => {
          let obj = {
            userId: item.userId,
            userName: item.userName,
            headId: item.id,
          };
          this.searchMenNames.push(obj);
          this.userIdList.push(item.userId);
        });
      } else {
        this.employeeList1 = [];
        this.userIdList1 = [];
        val.sendArray.forEach((item) => {
          this.employeeList1 = [...this.employeeList1, item.userName];
          this.userIdList1 = [...this.userIdList1, item.userId];
        });
        this.getEmployeeList();
      }
      this.dialogVisibleTree = false;
      this.isFlag = false;
    },
    setChart(xData, index, color = ["#2478f2"]) {
      //#f39423
      let machart = this.$echarts.getInstanceByDom(
        document.getElementById(`left${index}`)
      ); //有的话就获取已有echarts实例的DOM节点。
      if (machart == null) {
        // 如果不存在，就进行初始化。
        machart = this.$echarts.init(document.getElementById(`left${index}`));
      }
      var option;
      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          // orient: 'vertical',
          left: "center",
          top: 30,
        },
        series: [
          {
            name: "暂无数据",
            type: "pie",
            radius: "50%",
            data: xData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      //   }

      // 使用刚指定的配置项和数据显示图表。
      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function() {
        machart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.code-search-left {
  display: flex;
  align-items: center;
  /deep/.add-per-input {
    margin-right: 10px;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    cursor: pointer;

    .el-icon-close {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
    }
  }
}
.tips {
  /deep/.el-checkbox__input .el-checkbox__inner {
    border-radius: 10px;
  }
}
.select {
  height: 50px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  display: flex;
}
.header {
  flex: 1;
  height: 70px;
  padding-left: 30px;
  // border: 1px solid #1296DB;
  .ctx {
    width: 270px;
    height: 60px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    .left {
      width: 50px;
      text-align: center;
      font-size: 30px;
    }
    .center {
      flex: 1;
      font-size: 12px;
      .num {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .right {
      flex: 1;
      text-align: right;
      font-size: 13px;
      color: #aaa;
      margin-top: 25px;
      cursor: pointer;
    }
  }
}
</style>
